import "./App.css";
import React from "react";
import Routes from "./Routes";
import Store from "./redux/store";
import { Provider } from "react-redux";

import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Provider store={Store()}>
        <Routes />
      </Provider>
    </BrowserRouter>
  );
}

export default App;
